import MapDisplay from "../features/Map/components/MapDislay/MapDisplay";
import MediaControls from "../features/MediaControls";
import ControlPanel from "../features/ControlPanel";
import Logout from "../features/Auth/components/Logout/Logout";
import NotificationManager from "../features/Notifications/components/NotificationManager/NotificationManager";
import LivekitRoomComponent from "../features/MediaPlayback/components/livekitRoomComponent/LivekitRoomComponent";
import LivekitGlobalRoomComponent from "../features/MediaPlayback/components/LivekitGlobalRoom/LivekitGlobalRoomComponent";
import Auth from "../features/Auth/components/Auth/Auth";
import MapSelect from "../features/Map/components/MapSelect/MapSelect";
import FloatingReaction from "../features/MediaControls/components/FloatingReaction/FloatingReaction";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import WelcomeModal from "../features/Auth/components/WelcomeModal/welcomeModal";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { joinRoom } from "../features/ControlPanel/store/interact/interactThunks";
import WhiteBoardManager from "../features/Whiteboard/WhiteBoardManager.jsx";
import FooterContainer from "./Containers/FooterContainer.jsx";
export default function MainLayout() {
  const { roomId, mapId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (roomId && mapId) {
     dispatch(
      joinRoom({ body: { targetRoomId: roomId } })
    );
     navigate("/");

    }
  }, [roomId, mapId]);

    return (
   <div>
      <MapDisplay>
      </MapDisplay>
      <FooterContainer />
      <ControlPanel />
      <Logout />
      <LivekitRoomComponent />
      <LivekitGlobalRoomComponent />
      <Auth />
      <div style={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        maxHeight: "100vh",
        height: "fit-content",
        width: "fit-content",
        left: "20px",
        top: "20px",
        position: "absolute"
      }}>
      <MapSelect />
      <NotificationManager/>
      <WelcomeModal />
      <WhiteBoardManager/>
      </div>
      <FloatingReaction />
      
    </div>

    );
  }